import { _api as api } from '@/components/context/ApiContext';

export const getServerInfo = {
  queryKey: ['serverinfo'],
  queryFn: async () => {
    return (await api.get('info').json()) as { git_sha: string };
  }
};
